import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="aboutus-container">
      {/* Simple Page Title Section */}
      <section className="page-header">
        <div className="container">
          <h1 className="page-title2">About Us</h1>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="main-content">
        <div className="container">
          <div className="content-grid">
            {/* Left Image */}
            <div className="image-section">
              <div className="main-image">
                <img 
                  src="/assets/images/c2.png" 
                  alt="Modern Office Building" 
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="text-section">
              <div className="badge">
                <p className='p'>Leading business advisory and consulting firm</p>
              </div>
              <h1 className="section-title4">Where Experience Meets Excellence</h1>
              <p className="section-description">
                Pecunia Innovations(R) is a leading business advisory and consulting firm based in India, committed to enabling global organizations to establish and scale their operations in the Indian market. With an in-depth understanding of India's legal, regulatory, and financial ecosystems, we deliver comprehensive solutions-from company incorporation to full operational management and compliance oversight.
              </p><br/>
              
              <div className="button-container">
                <button className="explore-btn">Explore Now</button>
              </div>

              {/* Statistics */}
              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-number">25+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500K</div>
                  <div className="stat-label">Global Clients</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">150+</div>
                  <div className="stat-label">Expert Team</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">99%</div>
                  <div className="stat-label">Client Satisfaction</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Mission Section */}
      <section className="vision-mission">
        <div className="container">
          <div className="vm-grid">
            <div className="vm-item">
              <div className="vm-icon">
                <span className="icon-vision">👁️</span>
              </div>
              <h3>Vision</h3>
              <p>
                Pecunia has empowered clients across industries to navigate the complexities of the Indian business landscape with confidence. Our integrated outsourcing model allows businesses to focus on strategic growth while we manage their back-office, compliance, and regulatory functions.
              </p>
            </div>
            <div className="vm-item">
              <div className="vm-icon">
                <span className="icon-mission">🎯</span>
              </div>
              <h3>Mission</h3>
              <p>
                To simplify Indian business operations, financial services, and compliance processes for global and domestic enterprises through expert-driven, reliable, and holistic advisory and outsourcing services.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;